import React from 'react';

import { BaseOrderView } from 'views/BaseOrderView';

import {
  RosaOneLayout,
  RosaOnePaymentDetails,
  RosaOnePaymentLoading,
  RosaOnePaymentStatus,
} from './components';

export const RosaOneOrderView: React.FC = () => (
  <BaseOrderView
    overrideComponents={{
      Layout: RosaOneLayout,
      PaymentDetails: RosaOnePaymentDetails,
      PaymentLoading: RosaOnePaymentLoading,
      PaymentStatus: RosaOnePaymentStatus,
    }}
  />
);
